module.exports = __webpack_public_path__ + "img/waltChargerConnect.f0593ff1.svg";